import React from "react";
import CodeEditorMock from "../Panels/CodeEditorMock";
import arncAIImg from "../../assets/images/arncai.jpg";

const MertGPT = () => {
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          arncAI
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content single-project">
        <div className="left">
          <CodeEditorMock>
            Built a{" "}
            <span class="function-color op-1">custom AI chatbot platform</span>{" "}
            named <span class="html-color-text op-1">arncAI</span>, designed as
            a{" "}
            <span class="string-color-text op-1">ChatGPT-style assistant</span>{" "}
            powered by <span class="google-color-text op-1">Gemini API</span>.
            <br />
            <br />
            The system features a{" "}
            <span class="nodejs-color-text op-1">
              full authentication layer
            </span>{" "}
            and a{" "}
            <span class="docker-color-text op-1">
              user-specific chat memory
            </span>{" "}
            mechanism that{" "}
            <span class="function-color op-1">stores conversation history</span>{" "}
            across sessions. Each user has access to their past interactions
            with the model, allowing for a{" "}
            <span class="string-color-text op-1">personalized experience</span>{" "}
            across different sessions.
            <br />
            <br />
            Backend was developed using{" "}
            <span class="nodejs-color-text op-1">Node.js</span> and{" "}
            <span class="nodejs-color-text op-1">Express</span>, with{" "}
            <span class="sql-color-text op-1">SQL</span> used to manage{" "}
            <span class="string-color-text op-1">user data</span>,{" "}
            <span class="string-color-text op-1">chat logs</span>, and{" "}
            <span class="string-color-text op-1">session tokens</span>. The
            architecture supports{" "}
            <span class="function-color op-1">secure access</span> and{" "}
            <span class="docker-color-text op-1">
              efficient query performance
            </span>
            .
            <br />
            <br />
            On the frontend, the interface was built using{" "}
            <span class="react-color-text op-1">React</span>, with a focus on{" "}
            <span class="function-color op-1">clean UI</span> and{" "}
            <span class="string-color-text op-1">real-time interaction</span>.
            Users can{" "}
            <span class="function-color op-1">initiate new chats</span>, revisit{" "}
            <span class="string-color-text op-1">past conversations</span>, and
            receive{" "}
            <span class="google-color-text op-1">AI-generated responses</span>{" "}
            via the <span class="google-color-text op-1">Gemini LLM</span>{" "}
            endpoint.
          </CodeEditorMock>
        </div>
        <div className="right">
          <p className="comment">// ChatGPT clone project</p>
          <img src={arncAIImg} alt="arncai" />
          <p className="comment">// Create message code snippet</p>
          <div className="box-container">
            <CodeEditorMock>
              <span class="const-color">const</span> {"{"}{" "}
              <span class="string-color-text op-1">userId</span> {"}"} ={" "}
              <span class="function-color op-1">useAuth</span>();
              <br />
              <span class="const-color">const</span>{" "}
              <span class="string-color-text op-1">mutation</span> ={" "}
              <span class="function-color op-1">useMutation</span>({"{"}
              <br />
              &nbsp;&nbsp;<span class="string-color-text op-1">mutationFn</span>
              : () =&gt; {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="const-color">return</span>{" "}
              <span class="function-color op-1">fetch</span>(
              <span class="html-color-text op-1">
                `/api/chats/${"{"}data._id{"}"}`
              </span>
              , {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="string-color-text op-1">method</span>:{" "}
              <span class="string-color-text op-1">"PUT"</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="string-color-text op-1">headers</span>: {"{"}{" "}
              <span class="string-color-text op-1">"Content-Type"</span>:{" "}
              <span class="string-color-text op-1">"application/json"</span>{" "}
              {"}"},
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="string-color-text op-1">body</span>:{" "}
              <span class="function-color op-1">JSON.stringify</span>({"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="string-color-text op-1">question</span>:
              question.length ? question :{" "}
              <span class="const-color">undefined</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="string-color-text op-1">answer</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="string-color-text op-1">img</span>:
              img.dbData?.filePath || <span class="const-color">undefined</span>
              ,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="string-color-text op-1">userId</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"}"})
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"}).
              <span class="function-color op-1">then</span>((res) =&gt; res.
              <span class="function-color op-1">json</span>());
              <br />
              &nbsp;&nbsp;{"}"},
              <br />
              &nbsp;&nbsp;<span class="string-color-text op-1">onSuccess</span>:
              () =&gt; {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;queryClient.
              <span class="function-color op-1">invalidateQueries</span>({"{"}{" "}
              queryKey: [<span class="string-color-text op-1">"chat"</span>,
              data._id {"}"}).<span class="function-color op-1">then</span>(()
              =&gt; {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;formRef.current.
              <span class="function-color op-1">reset</span>();
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color op-1">setQuestion</span>(
              <span class="string-color-text op-1">""</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color op-1">setAnswer</span>(
              <span class="string-color-text op-1">""</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color op-1">setImg</span>({"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;isLoading:{" "}
              <span class="boolean-color-text">false</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;error:{" "}
              <span class="string-color-text op-1">""</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;dbData: {"{"}
              {"}"},
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;aiData: {"{"}
              {"}"},
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"}"});
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"});
              <br />
              &nbsp;&nbsp;{"}"},
              <br />
              &nbsp;&nbsp;<span class="string-color-text op-1">onError</span>:
              (err) =&gt; {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color op-1">console.log</span>(err);
              <br />
              &nbsp;&nbsp;{"}"},
              <br />
              {"}"});
              <br />
              <br />
              <span class="const-color">const</span>{" "}
              <span class="function-color op-1">add</span> ={" "}
              <span class="const-color">async</span> (text, isInitial) =&gt;{" "}
              {"{"}
              <br />
              &nbsp;&nbsp;<span class="const-color">if</span> (!isInitial){" "}
              <span class="function-color op-1">setQuestion</span>
              (text);
              <br />
              &nbsp;&nbsp;<span class="const-color">try</span> {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="const-color">const</span> result ={" "}
              <span class="const-color">await</span> chat.
              <span class="function-color op-1">sendMessageStream</span>(
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="const-color">Object.entries</span>
              (img.aiData).length ? [img.aiData, text] : [text]
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="const-color">let</span> accumulatedText ={" "}
              <span class="string-color-text op-1">""</span>;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="const-color">for await</span> (
              <span class="const-color">const</span> chunk{" "}
              <span class="const-color">of</span> result.stream) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="const-color">const</span> chunkText = chunk.
              <span class="function-color op-1">text</span>();
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color op-1">console.log</span>(chunkText);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;accumulatedText += chunkText;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color op-1">setAnswer</span>
              (accumulatedText);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;mutation.
              <span class="function-color op-1">mutate</span>();
              <br />
              &nbsp;&nbsp;{"}"} <span class="const-color">catch</span> (err){" "}
              {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color op-1">console.log</span>(err);
              <br />
              &nbsp;&nbsp;{"}"}
              <br />
              {"}"};
              <br />
              <br />
              <span class="const-color">const</span>{" "}
              <span class="function-color op-1">handleSubmit</span> ={" "}
              <span class="const-color">async</span> (e) =&gt; {"{"}
              <br />
              &nbsp;&nbsp;e.
              <span class="function-color op-1">preventDefault</span>();
              <br />
              &nbsp;&nbsp;<span class="const-color">const</span> text =
              e.target.text.value;
              <br />
              &nbsp;&nbsp;<span class="const-color">if</span> (!text){" "}
              <span class="const-color">return</span>;
              <br />
              &nbsp;&nbsp;add(text,{" "}
              <span class="boolean-color-text">false</span>);
              <br />
              {"}"};
              <br />
              <br />
              <span class="comment-color op-1">
                // IN PRODUCTION WE DON'T NEED IT
              </span>
              <br />
              <span class="const-color">const</span> hasRun ={" "}
              <span class="function-color op-1">useRef</span>(
              <span class="boolean-color-text">false</span>);
              <br />
              <br />
              <span class="function-color op-1">useEffect</span>(() =&gt; {"{"}
              <br />
              &nbsp;&nbsp;<span class="const-color">
                if
              </span> (!hasRun.current) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">if</span>{" "}
              (data?.history?.length === 1) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;add(data.history[0].parts[0].text,{" "}
              <span class="boolean-color-text">true</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"}
              <br />
              &nbsp;&nbsp;{"}"}
              <br />
              &nbsp;&nbsp;hasRun.current ={" "}
              <span class="boolean-color-text">true</span>;
              <br />
              {"}"}, []);
            </CodeEditorMock>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MertGPT;
